import { WorkflowVersionStatus } from 'dashboard/models/workflow-version';
import Sticker from 'design-system/components/Sticker';
import { Variant } from 'design-system/theme';
import { assertNever } from 'lib/utils/types';

interface AccountActionVersionStatusStickerProps {
  status: WorkflowVersionStatus;
}

const AccountActionVersionStatusSticker = ({ status }: AccountActionVersionStatusStickerProps) => {
  const getStickerStatus = (): [Exclude<Variant, 'inverse'>, string] => {
    switch (status) {
      case WorkflowVersionStatus.Published: {
        return ['success', 'Published'];
      }
      case WorkflowVersionStatus.Draft: {
        return ['primary', 'Draft'];
      }
      case WorkflowVersionStatus.Archived: {
        return ['caution', 'Archived'];
      }
      case WorkflowVersionStatus.Created: {
        return ['primary', 'Created'];
      }
      case WorkflowVersionStatus.Pending: {
        return ['primary', 'Pending'];
      }
      case WorkflowVersionStatus.Completed: {
        return ['success', 'Completed'];
      }
      default:
        assertNever(status);
    }
  };

  const [variantType, statusMessage] = getStickerStatus();

  return <Sticker variant={variantType}>{`Version: ${statusMessage}`}</Sticker>;
};

export default AccountActionVersionStatusSticker;
